import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin } from "lucide-react";
import { api } from "@/api";
import { LogoMark } from "@/components/Header";

export default function Footer() {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const email = settings?.contact_email || "goldenauraprof@gmail.com";

  return (
    <footer className="border-t border-[#D4AF37]/15 bg-[#080C17]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <LogoMark size={52} />
            <span className="font-display text-lg tracking-[0.18em]">GOLDEN <span className="gold-text">AURA</span> PRO</span>
          </div>
          <p className="text-sm text-[#9AA3B5] leading-relaxed">
            Conciergerie de prestige &amp; location de courte durée. Confort, sérénité et professionnalisme pour chaque séjour.
          </p>
        </div>

        <div data-testid="footer-contact">
          <h3 className="text-xs tracking-[0.28em] uppercase text-[#D4AF37] mb-5">Contact</h3>
          <ul className="space-y-3 text-sm text-[#B9BFD0]">
            <li>
              <a href={`mailto:${email}`} className="flex items-center gap-3 hover:text-[#E5C158] transition-colors" data-testid="footer-email-link">
                <Mail size={16} className="text-[#D4AF37]" /> {email}
              </a>
            </li>
            {settings?.phone && (
              <li>
                <a href={`tel:${settings.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 hover:text-[#E5C158] transition-colors" data-testid="footer-phone-link">
                  <Phone size={16} className="text-[#D4AF37]" /> {settings.phone}
                </a>
              </li>
            )}
            <li>
              <a href={settings?.instagram_url || "https://www.instagram.com/golden_aura.conciergerie"} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#E5C158] transition-colors" data-testid="footer-instagram-link">
                <Instagram size={16} className="text-[#D4AF37]" /> @golden_aura.conciergerie
              </a>
            </li>
            {settings?.facebook_url && (
              <li>
                <a href={settings.facebook_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 hover:text-[#E5C158] transition-colors" data-testid="footer-facebook-link">
                  <Facebook size={16} className="text-[#D4AF37]" /> GOLDEN AURA PRO
                </a>
              </li>
            )}
            <li className="flex items-center gap-3" data-testid="footer-zone">
              <MapPin size={16} className="text-[#D4AF37]" /> {settings?.zone || "Oyonnax, Lyon et alentours"}
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-xs tracking-[0.28em] uppercase text-[#D4AF37] mb-5">Informations</h3>
          <ul className="space-y-3 text-sm text-[#B9BFD0]">
            <li><Link to="/mentions-legales" className="hover:text-[#E5C158] transition-colors" data-testid="footer-legal-link">Mentions légales</Link></li>
            <li><Link to="/confidentialite" className="hover:text-[#E5C158] transition-colors" data-testid="footer-privacy-link">Politique de confidentialité</Link></li>
            <li><Link to="/contact" className="hover:text-[#E5C158] transition-colors" data-testid="footer-contact-link">Nous contacter</Link></li>
            <li><Link to="/admin" className="hover:text-[#E5C158] transition-colors" data-testid="footer-admin-link">Espace propriétaire</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D4AF37]/10 py-6 text-center text-xs text-[#6B7385] tracking-[0.15em] uppercase">
        © {new Date().getFullYear()} Golden Aura Pro — Tous droits réservés
      </div>
    </footer>
  );
}
